import Vue from "vue";
import VueMaterial from "vue-material";

import VueMaterialPatch from "lib/plugins/VueMaterialPatch";
import App from "App";
import IE11RouterFix from "lib/mixins/IE11RouterFix";
import Notification from "lib/components/Notification";
import cssVars from "lib/modules/CssVars";
import cookie from "lib/modules/Cookie";
import router from "router";

cssVars.init();

window.$bus = new Vue();

Vue.use(VueMaterial);
Vue.use(VueMaterialPatch);

new Vue({
	el: "#app",
	router,
	mixins: [IE11RouterFix],
	render(h) {
		return h(App);
	}
});

new Vue({
	el: "#notification",
	mounted() {
		cookie.checkConsent();
	},
	render(h) {
		return h(Notification);
	}
});
